import { PhoneOutlinedIcon } from '@village/icons';
import { Button } from '@village/ui';
import { useAppOptions, useCaptureCountlyEvent } from 'hooks';
import { FC } from 'react';
import { formatPhoneWithNoDash } from 'utils/phone-number';

import * as Styled from './styles';

interface Props {
    phoneNumber: string;
}

const CallButton: FC<Props> = ({ phoneNumber }) => {
    const { addCountlyEvent } = useCaptureCountlyEvent();
    const appOptions = useAppOptions();

    const handleClickToCall = () => {
        addCountlyEvent({ key: 'clickToCall' });
    };

    return (
        <Styled.ButtonWrapper $appType={appOptions.type}>
            <Button
                startIcon={<PhoneOutlinedIcon />}
                variant="secondary"
                size="medium"
                fullWidth={true}
                onClick={() => handleClickToCall()}
                data-testid="scheduling-not-available-phone"
            >
                <Styled.Link href={`tel:${formatPhoneWithNoDash(phoneNumber)}`} />
                {phoneNumber}
            </Button>
        </Styled.ButtonWrapper>
    );
};

export default CallButton;
